module.exports = __webpack_public_path__ + "static/media/LOGO DATA ACADEMY-01.63a8aca8.png";